import { Product } from '../types';
import 'swiper/css';
import { Link } from 'react-router-dom';
import { SwiperComponent } from '../helper/swiper-component';
import { AppModal } from './modal';
import SingleProduct from '../pages/single-product';
import { Container, Spinner } from 'react-bootstrap';
import { useState } from 'react';
import { useCart } from '../context/cart-context';
import { PlaceholderLoader } from './placeholder';

interface NewArrivalsProps {
  products: Product[]
  loading: boolean;
}

const NewArrivals = ({ products, loading }: NewArrivalsProps) => {

  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<Product|null>(null);

  const handleModal = () => setIsShowModal(!isShowModal);

  const { cartItems } = useCart();

  const handleSelctedProduct = (product: Product) => setSelectedProduct(product);


  return (
    <section id="new-arrival" className="product-carousel py-5 position-relative overflow-hidden">
      <div className="container">
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-5 mb-3">
          <h4 className="text-uppercase">Our Products</h4>
          <Link to="/shop" className="btn-link">View All Products</Link>
        </div>
        {loading ? 
          <div className='row'> {
            [1,2,3,4].map(e => <div className='col-lg-3'><PlaceholderLoader /></div>) 
          } </div>: 
          <SwiperComponent products={products} handleSelctedProduct={handleSelctedProduct} handleModal={handleModal} />
        }

      </div>
      <AppModal 
        isShowModal={isShowModal}
        handleCloseModal={handleModal}
        size='xl'
        children={
            selectedProduct ? 
            <SingleProduct product={selectedProduct} currentQty={cartItems.find(p => p.id === selectedProduct.id)?.quantity||1} /> : 
            <Container className='d-flex flex-row justify-content-center align-item-center'><Spinner animation="border" variant='primary' /></Container>
        }
      />
    </section>
  );
};

export default NewArrivals;